import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ResponsiveContainer-module_container_box__vbXde {\n  display: flex;\n  flex-wrap: wrap;\n}";
var Styles = {"container_box":"ResponsiveContainer-module_container_box__vbXde"};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=ResponsiveContainer.module.scss.js.map
